import Axios, {AxiosRequestConfig, AxiosResponse} from "axios"

export interface SavingsAndPension {
  savings?: Savings
  pension?: Pension
}

export interface Savings {
  savingsModestSingle: number
  savingsModestCouple: number
  savingsComfortableSingle: number
  savingsComfortableCouple: number
}

export interface Pension {
  pensionSingle: number
  pensionCouple: number
}

export interface AsfaVariables {
  at: string
  pdfUrl: string
  savingsModestSingle: number
  savingsModestCouple: number
  savingsComfortableSingle: number
  savingsComfortableCouple: number
  pensionSingle: number
  pensionCouple: number
  modestSingleYearTotal: number
  modestCoupleYearTotal: number
  comfortableSingleYearTotal: number
  comfortableCoupleYearTotal: number
}

export class AsfaVariableService {
  async get(): Promise<AsfaVariables> {
    return Axios.get("/api/asfa").then((response: AxiosResponse<AsfaVariables>) => response.data)
  }

  async set(
    asfa: AsfaVariables | null,
    save = false,
    file: File | null = null
  ): Promise<AsfaVariables> {
    const sap: SavingsAndPension =
      asfa && save
        ? {
            savings: {
              savingsModestSingle: asfa.savingsModestSingle,
              savingsModestCouple: asfa.savingsModestCouple,
              savingsComfortableSingle: asfa.savingsComfortableSingle,
              savingsComfortableCouple: asfa.savingsComfortableCouple,
            },
            pension: {
              pensionSingle: asfa.pensionSingle,
              pensionCouple: asfa.pensionCouple,
            },
          }
        : {}

    const formData = new FormData()
    if (file != null) formData.append("file", file)

    formData.append(
      "savingsAndPension",
      new Blob([JSON.stringify(sap)], {type: "application/json"})
    )

    const parameters: AxiosRequestConfig = {params: {save}}

    return Axios.post("/api/asfa", formData, parameters).then(
      (response: AxiosResponse<AsfaVariables>) => response.data
    )
  }
}
